import styled from "styled-components";

const primaryHighlight = "#F96302";
const activeTab = `4px solid ${primaryHighlight}`;
const inactiveTab = `4px solid transparent`;

export const TabContainer = styled.div`
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: ${(props) => (props.isActive ? activeTab : inactiveTab)};
  cursor: pointer;
  @media (min-width: 768px) {
    &:hover {
      background-color: rgb(255, 244, 237);
      border-bottom: ${(props) =>
        props.isActive ? activeTab : "4px solid rgb(254, 212, 185)"};
      transition: all 0.25s cubic-bezier(0.25, 0, 1, 1) 0s;
    }
  }
`;

export const TabText = styled.p`
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0;
  padding: 0 1rem;
  color: ${(props) => (props.isActive ? "#000" : "#666")};
`;
